import { __exportAll } from "../../_virtual/_rolldown/runtime.js";

//#region src/types/plugins/ContainerReferencePlugin.ts
var ContainerReferencePlugin_exports = /* @__PURE__ */ __exportAll({});

//#endregion
export { ContainerReferencePlugin_exports };
//# sourceMappingURL=ContainerReferencePlugin.js.map